import { useState } from 'react';

import { ANIMATION_DURATION } from 'containers/admin/clients/client/tabs-components/products-tab/product/report-assignment/report-assignment.constants';

type FetchData = (id: string | number) => Promise<unknown> | unknown;

interface UseExpandableResult {
  isExpanded: boolean;
  isPending: boolean;
  isClosing: boolean;
  toggle: (id: string | number, hasData: boolean) => Promise<void>;
}

export const useExpandable = (fetchData: FetchData): UseExpandableResult => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);

  const toggle = async (
    id: string | number,
    hasData: boolean,
  ): Promise<void> => {
    if (isPending) return;

    if (isExpanded) {
      setIsClosing(true);
      setTimeout(() => {
        setIsExpanded(false);
        setIsClosing(false);
      }, ANIMATION_DURATION);
    } else {
      setIsExpanded(true);

      if (!hasData && fetchData) {
        setIsPending(true);
        try {
          await fetchData(id);
        } catch (error) {
          console.error('Error loading data:', error);
        } finally {
          setIsPending(false);
        }
      }
    }
  };

  return {
    isExpanded,
    isPending,
    isClosing,
    toggle,
  };
};
